import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Navigation from '../Navigation'

import Link from 'next/link'
import { default as OutlineButton } from '@/general/component/button'
import Select from '@components/atom/Select'
import Menu from '@components/atom/IconMenu'
import Dropdown from '@/general/component/dropdown/menu'

import Authentication from '@/account/template'
import NumberPeople from '@/layout/component/header/peopleNumber'
// import { WeatherInformation } from '@/layout/component/header/community/weather'

import { getAccountState, signOut } from '@/account/state'
import { getLandingState, selectLanguage } from '@/landing/state'

import useModal from '@helper/util/useModal'
import { getFirstName } from '@helper/util/useCase'

import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  width: 100vw;
`
const Top = styled.div`
  background: #fff;
  // background: linear-gradient(270deg, #FFE5CF 5.98%, #FFFFFF 84.07%);
  padding: 0.5rem 0;
  width: 100%;
  .container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`
const GnB = styled.div`
  align-items: center;
  background-color: #fff;
  box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  /* padding: 0 5em; */
  height: 8vh;
  width: 100%;
  .container {
    align-items: center;
    display: flex;
    justify-content: space-between;
  }
`
const Column = styled.div`
  align-items: center;
  display: flex;
  // justify-content: space-between;
  // .padded{
  //     margin: 0 .5em;
  // }
`

const UserAccount = styled.div`
  display: flex;
  align-items: center;
  img {
    margin: 0 0.5em;
    border-radius: 50%;
    height: 32px;
    width: 32px;
  }
`

const Header = () => {
  const dispatch = useDispatch()
  const { callModal } = useModal()

  const { address, isSignedIn, userProfile } = useSelector(getAccountState)
  const { language } = useSelector(getLandingState)

  const { firstName, image } = userProfile

  const setLanguage = (lang) => dispatch(selectLanguage(lang))

  const [environment, setEnvironment] = useState('Neighborhoods')
  useEffect(() => { setEnvironment('Neighborhoods') }, [])

  return (
    <Container className="sticky top-0 z-50">
      <Top>
        <div className="container mx-auto">
          <Column>
            <NumberPeople
              location=""
              address="#03-01, 62, UBI ROAD 1, OXLEY BIZHUB 2"
            />
          </Column>
          <Column>
            {/* <WeatherInformation /> */}
            <div>
              <Select
                value={language}
                onChange={(e) => setLanguage(e.target.value)}
                options={[
                  { label: 'English', value: 'en' },
                  { label: 'Indonesia', value: 'id' }
                ]}
              />
            </div>
          </Column>
        </div>
      </Top>
      <GnB>
        <div className="container mx-auto">
          <Column>
            <Dropdown
              items={[
                { id: 1, label: 'Test 1' },
                { id: 2, label: 'Test 2' }
              ]}
            >
              <Menu tooltip="Menu" className="padded">
                <img src="/menu/Hamburger.png" />
              </Menu>
            </Dropdown>
            <div className="padded">
              <Link href="/" passHref>
                <a href="">
                  <img src="/media/logo/main-round.png" alt="" />
                </a>
              </Link>
            </div>
            <Select
              icon={<img src="/media/icon_png/Location.png" alt="" />}
              options={
                address &&
                address.map((_address) => ({
                  label: _address.general_location,
                  value: _address.id
                }))
              }
            />
            <Select
              className="with-margin"
              options={[
                { label: 'All', value: 'all' },
                {
                  label: 'Same Building & Street',
                  value: 'SameBuildingStreet'
                },
                { label: 'Neighborhoods', value: 'Neighborhoods' }
              ]}
              value={environment}
            />
          </Column>
          <Column>
            <div className="padded">
              <Navigation
                navigation={[
                  { title: 'Buy & Sell', link: 'buyandsell', default: true },
                  { title: 'Around', link: 'around' }
                ]}
              />
            </div>
            <Dropdown
              items={[
                { id: 1, label: 'Test 1' },
                { id: 2, label: 'Test 2' }
              ]}
            >
              <Menu tooltip="Add" className="padded">
                <img src="/menu/Add.png" />
              </Menu>
            </Dropdown>
            <Dropdown
              items={[
                { id: 1, label: 'Test 1' },
                { id: 2, label: 'Test 2' }
              ]}
            >
              <Menu tooltip="Category" className="padded">
                <img src="/menu/Category.png" />
              </Menu>
            </Dropdown>
            <Dropdown
              items={[
                { id: 1, label: 'Test 1' },
                { id: 2, label: 'Test 2' }
              ]}
            >
              <Menu tooltip="Notification" className="padded">
                <img src="/menu/Notification.png" />
              </Menu>
            </Dropdown>
            <Dropdown
              items={[
                { id: 1, label: 'Test 1' },
                { id: 2, label: 'Test 2' }
              ]}
            >
              <Menu tooltip="Chat" className="padded">
                <img src="/menu/Chat.png" />
              </Menu>
            </Dropdown>
            <div>
              {!isSignedIn
                ? (
                <OutlineButton
                  className="round"
                  onClick={() => callModal(<Authentication />)}
                >
                  Sign in
                </OutlineButton>
                  )
                : (
                <Dropdown
                  invert
                  items={[
                    {
                      id: 2,
                      label: 'Sign Out',
                      onClick: () => dispatch(signOut())
                    }
                  ]}
                >
                  <UserAccount>
                    Hi,&nbsp;<strong>{getFirstName(firstName)}</strong>{' '}
                    <img src={image} alt="" />
                  </UserAccount>
                </Dropdown>
                  )}
            </div>
          </Column>
        </div>
      </GnB>
    </Container>
  )
}

export default Header
